import axios from 'axios'
import { API_URL } from '../../../../constants'
import { ApiResponse } from '../../../common/api/response.types'
import {
  FlowControlRefusalCard,
  FlowControlRefusalListItem,
  FlowControlRefusalListParams,
  PayoutFlowControlDecision,
  PayoutRefusalCard,
  PayoutRefusalListItem,
  PayoutRefusalListParams,
} from './refusal.types'

export const PAYOUT_REFUSAL_URL = `${API_URL}/api/internal/payout-refusal`
export const FLOW_CONTROL_REFUSAL_URL = `${API_URL}/api/internal/matching/payout-refusal`

export const getPayoutRefusals = (params: PayoutRefusalListParams) =>
  axios.get<ApiResponse<PayoutRefusalListItem[]>>(`${PAYOUT_REFUSAL_URL}/list`, { params })

export const getPayoutRefusalCard = (id: number | string) =>
  axios.get<ApiResponse<PayoutRefusalCard>>(`${PAYOUT_REFUSAL_URL}/${id}`)

export const getFlowControlRefusals = (params: FlowControlRefusalListParams) =>
  axios.get<ApiResponse<FlowControlRefusalListItem[]>>(`${FLOW_CONTROL_REFUSAL_URL}/list`, { params })

export const getFlowControlRefusalCard = (id: number | string) =>
  axios.get<ApiResponse<FlowControlRefusalCard>>(`${FLOW_CONTROL_REFUSAL_URL}/${id}`)

export const getPayoutFlowControlDecisions = (token: string) =>
  axios.get<ApiResponse<PayoutFlowControlDecision[]>>(`${FLOW_CONTROL_REFUSAL_URL}/by-payout/${token}`)
